import React from "react";
import { Chip } from "@mui/material";
import moment from "moment";
import { displayStatutCourse, displayStatutCourseDetail, hasBlockingDeclarationStatus, resolveStatutCourse } from "../../Utils/Function";

/**
 * Statut d'un cours côté client, copié de `ClientListCourse` sans changement
 * de règle : la pastille URSSAF (`displayStatutCourse`) pour un cours passé
 * ou bloqué par sa déclaration, sinon une puce selon la date.
 */

// Même valeur que dans la liste actuelle (`any`) : les helpers acceptent null.
const errorsDescription = (course: any): any => course?.errorsStatusDescription?.[0]?.description ?? null;

const dateStatus = (course: any): { label: string; chip: React.ReactNode } => {
    const now = moment();
    const start = moment(course?.startDatetime);
    const end = moment(course?.endDatetime);
    if (start.isSame(now, "day")) return { label: "Aujourd'hui", chip: <Chip label="Aujourd'hui" size="small" color="success" variant="filled" /> };
    if (now.isBetween(start, end, "day", "[]")) return { label: "En cours", chip: <Chip label="En cours" size="small" color="info" variant="filled" /> };
    if (start.isAfter(now)) return { label: "À venir", chip: <Chip label="À venir" size="small" color="primary" variant="outlined" /> };
    return { label: "Passé", chip: <Chip label="Passé" size="small" color="default" variant="outlined" /> };
};

const usesUrssafStatus = (course: any, isHistorique: boolean): boolean =>
    isHistorique || hasBlockingDeclarationStatus(course?.declarationStatus);

/** Pastille de la ligne. */
export const clientCourseStatusNode = (course: any, isHistorique: boolean, classes: any): React.ReactNode => {
    if (usesUrssafStatus(course, isHistorique)) {
        return displayStatutCourse(course?.urssafServiceStatus, course?.statusDescription, errorsDescription(course), course?.isOver, false, classes, course?.declarationStatus, course?.declarationStatusReason);
    }
    return dateStatus(course).chip;
};

/** Pastille avec son explication, pour la fiche. */
export const clientCourseStatusDetail = (course: any, isHistorique: boolean, classes: any): React.ReactNode => {
    if (usesUrssafStatus(course, isHistorique)) {
        return displayStatutCourseDetail(course?.urssafServiceStatus, course?.statusDescription, errorsDescription(course), course?.isOver, classes, course?.declarationStatus, course?.declarationStatusReason, "left");
    }
    return dateStatus(course).chip;
};

/** Libellé court (« Validé », « En attente », « À venir »). */
export const clientCourseStatusLabel = (course: any, isHistorique: boolean): string => {
    if (usesUrssafStatus(course, isHistorique)) {
        return resolveStatutCourse(course?.urssafServiceStatus, course?.statusDescription, errorsDescription(course), course?.isOver, course?.declarationStatus, course?.declarationStatusReason).text;
    }
    return dateStatus(course).label;
};
